import styled, { css } from 'styled-components';

export const Actions = styled.div<{ $isActive?: boolean }>`
  border-right: ${({ $isActive, theme }) =>
    $isActive ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.grey[300]}`};
  background: ${({ theme }) => theme.palette.common.white};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px 0px 0px 8px;
`;

export const Container = styled.div<{ $withoutHeader?: boolean; $isActive?: boolean }>`
  display: flex;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.white};
  border: ${({ $withoutHeader, theme }) => ($withoutHeader ? 'none' : `1px solid ${theme.palette.grey[300]}`)};
  margin: ${({ $withoutHeader }) => ($withoutHeader ? '' : '16px')};
  margin-top: ${({ $withoutHeader }) => ($withoutHeader ? '' : '8px')};
  margin-bottom: 0;

  ${({ $isActive }) =>
    $isActive &&
    css`
      border: 1px solid ${({ theme }) => theme.palette.primary.main};
    `}
`;
